import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { confirmWebfleetBorders } from './confirmWebfleetBorders'
import {
  WebfleetBorderConfirmRequest,
  WebfleetBorderConfirmResponse,
} from './types'

export function useMutationConfirmWebfleetBorders(companyId: string) {
  return useMutation<
    AxiosResponse<WebfleetBorderConfirmResponse>,
    Error,
    WebfleetBorderConfirmRequest
  >({
    mutationFn: (payload) => confirmWebfleetBorders({ companyId, payload }),
  })
}
